import * as React from 'react';
import { Box, List, Typography } from '@mui/material';

import { ServiceItem } from '.';
import { IZoneServiceItem } from 'models';

interface ServiceItemListProps {
  serviceItems: Array<IZoneServiceItem>;
}

export const ServiceItemList: React.FC<ServiceItemListProps> = (props) => {
  const { serviceItems } = props;

  return serviceItems && serviceItems.length > 0 ? (
    <List>
      {(serviceItems || []).map((item) => (
        <ServiceItem key={`service-item-${item.id}`} serviceItem={item} />
      ))}
    </List>
  ) : (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 120,
      }}
    >
      <Typography color="textSecondary">No service item</Typography>
    </Box>
  );
};
